import { BaseEntity } from "yt-ng-framework";

export class KursDokumentStavkaView extends BaseEntity{
    constructor(){
        super();
    }

    Valuta: string;
    //Datum: string;
    VredDinS: number;
    VredDinP: number;
    VredDinK: number;   

    Deserialize(input:any){
        this.ID=input.ID;
        this.Valuta=input.Valuta;        
        this.VredDinS = input.VredDinS;
        this.VredDinP=input.VredDinP;
        this.VredDinK=input.VredDinK;      
        return this;
    }

    Serialize(input:KursDokumentStavkaView){
        return input;
    }
}